export type ELTRecord = {
  state: string | null;
  esn: string | null;
  jurisdiction: string | null;
  county: string | null;
  psap: string | null;
  law: string | null;
  fire: string | null;
  ems: string | null;
  ems2: string | null;
};

export const remove = (cell, formatterParams, onRendered) => {
  return `<calcite-icon id="trashIcon" icon="trash" scale="s"></calcite-icon>`;
};

export const options = (cell, formatterParams, onRendered) => {
  let id = cell.getData().idx;
  const hasWritePermission = formatterParams?.hasWritePermission;

  // if (hasWritePermission) {
  //   return `
  //     <a href="/elt-records/edit/${id}">
  //       <calcite-icon id="editError-${id}" icon="pencil" scale="s" style="margin-right:8px;"></calcite-icon>
  //     </a>
  //     <a href="/elt-records/delete/${id}">
  //       <calcite-icon id="deleteError-${id}" icon="trash" scale="s"></calcite-icon>
  //     </a>
  //   `;
  // } else {
  // read only
  return `
      <a title="View ELT Record" href="/elt-records/view/${id}">
        <calcite-icon id="viewError-${id}" icon="view-visible" scale="s"></calcite-icon>
      </a>
    `;
  //}
};

export function getELTExportColumns() {
  return {
    "Emergency Service Number": "ESN",
    PSAP: "PSAP",
    Jurisdiction: "Jurisdiction",
    EMS: "EMS",
    EMS2: "EMS2",
    Law: "LAW",
    Fire: "FIRE",
    County: "County",
    State: "State",
  };
}

export function getELTRecordColumns(hasWritePermission: boolean) {
  const eltRecordColumns: ColumnDefinition[] = [
    // Displayed columns
    // {
    //   title: "",
    //   field: "actions",
    //   formatter: options,
    //   formatterParams: {
    //     hasWritePermission,
    //   },
    //   width: 75,
    //   minWidth: 50,
    //   hozAlign: "center",
    //   headerSort: false,
    //   headerFilter: false,
    // },
    {
      title: "ESN",
      field: "ESN",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 120,
      // minWidth: 50,
    },
    {
      title: "PSAP",
      field: "PSAP",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 150,
      // minWidth: 150,
    },
    {
      title: "Jurisdiction",
      field: "Jurisdiction",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 150,
      // minWidth: 50,
    },
    {
      title: "EMS",
      field: "EMS",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 150,
      // minWidth: 150,
    },
    {
      title: "EMS2",
      field: "EMS2",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 150,
      // minWidth: 150,
    },
    {
      title: "Law",
      field: "LAW",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 150,
      // minWidth: 150,
    },
    {
      title: "Fire",
      field: "FIRE",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 150,
      // minWidth: 150,
    },
    {
      title: "State",
      field: "State",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 100,
      // minWidth: 50,
    },
    {
      title: "County",
      field: "County",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 120,
      // minWidth: 50,
    },
  ];

  // if(hasEditPermission) {
  //   aliErrorColumns.unshift({
  //     title: "",
  //     formatter: remove,
  //     width: 50,
  //     minWidth: 50,
  //     hozAlign: "center",
  //     headerSort: false,
  //   })
  // }

  return eltRecordColumns;
}
